import { render, staticRenderFns } from "./ResetPasswordCandidate.vue?vue&type=template&id=b76e1db6&scoped=true"
import script from "./ResetPasswordCandidate.vue?vue&type=script&lang=js"
export * from "./ResetPasswordCandidate.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordCandidate.vue?vue&type=style&index=0&id=b76e1db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76e1db6",
  null
  
)

export default component.exports